import React from 'react';

const SadFaceIcon = () => {
  return (
    <svg width="49" height="27" viewBox="0 0 49 27" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>
        Sad Face Icon
      </title>
      <path d="M13.992 0c1.078 0 1.953.363 2.625 1.09.672.726 1.008 1.637 1.008 2.73 0 1.11-.336 2.028-1.008 2.754-.672.727-1.547 1.09-2.625 1.09-1.062 0-1.926-.36-2.59-1.078-.664-.719-.996-1.64-.996-2.766 0-1.11.332-2.023.996-2.742C12.066.36 12.93 0 13.992 0zm19.195 0c1.079 0 1.954.363 2.625 1.09.672.726 1.008 1.637 1.008 2.73 0 1.11-.336 2.028-1.008 2.754-.671.727-1.546 1.09-2.625 1.09-1.062 0-1.925-.36-2.59-1.078-.663-.719-.995-1.64-.995-2.766 0-1.11.332-2.023.996-2.742C31.262.36 32.125 0 33.188 0zM24.54 13.523c3.578 0 6.984.477 10.219 1.43 3.234.953 6.097 2.36 8.59 4.219 2.492 1.86 4.222 3.875 5.191 6.047l-3.656 1.312c-1.688-2.281-4.297-4.062-7.828-5.343-3.532-1.282-7.657-1.922-12.375-1.922h-.727c-4.734 0-8.875.632-12.422 1.898-3.547 1.266-6.195 3.055-7.945 5.367L0 25.22c.953-2.125 2.637-4.106 5.05-5.942 2.415-1.836 5.2-3.238 8.356-4.207 3.157-.968 6.453-1.484 9.89-1.547h1.243z" fill="#262aff" fillRule="evenodd" />
    </svg>
  );
};

export default SadFaceIcon;
